import { render, staticRenderFns } from "./AppointmentList.vue?vue&type=template&id=14329a90&scoped=true"
import script from "./AppointmentList.vue?vue&type=script&lang=js"
export * from "./AppointmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14329a90",
  null
  
)

export default component.exports